import React from 'react';
import { TableContainer, TableRaw, TableRawItem } from './Table.style';
import { ScrollPanel } from '@toluna-ui-toolkit/scroll-panel';
import { CheckBox } from '@toluna-ui-toolkit/inputs';
import { ResponseObject } from '../data/models';

interface Props {
    data: Array<ResponseObject>;
    translations?: Record<string, string>;
    options: {
        onChecked: (id: ResponseObject['externalProjectId']) => void;
        onUnChecked: (id: ResponseObject['externalProjectId']) => void;
        checkedItems: Array<ResponseObject['externalProjectId']> | null;
    };
}

const wrapperStyles = {
    '.ScrollbarsCustom-Content': {
        display: 'block!important',
    },
};

const scrollPanelProps = {
    floatBar: false,
    customStyle: {
        contentWrapperWithScroll: {
            marginRight: '5px',
        },
    },
};

export const Table = React.forwardRef<React.ElementRef<typeof ScrollPanel>, Props>(
    ({ data, options: { onChecked, onUnChecked, checkedItems }, translations }, ref) => {
        const handlePreventScroll = () => {
            const currentRef = ref as React.RefObject<HTMLDivElement>;
            const scrollPosBeforeClick = currentRef.current?.scrollTop ?? 0;

            if (scrollPosBeforeClick > 0) {
                requestAnimationFrame(() => {
                    if (currentRef.current) {
                        currentRef.current.scrollTop = scrollPosBeforeClick;
                    }
                });
            }
        };

        const handleCheck = (checked: boolean, id: ResponseObject['externalProjectId']) => {
            checked ? onChecked(id) : onUnChecked(id);
            handlePreventScroll();
        };

        return (
            <TableContainer>
                <ScrollPanel maxHeight={400} ref={ref} wrapperStyles={wrapperStyles} {...scrollPanelProps}>
                    <TableRaw isHeader>
                        <TableRawItem isCheckbox />
                        <TableRawItem isBold>{translations?.TI2020_ContentTranslations_Header_UPSDatabaseProjectId}</TableRawItem>
                        <TableRawItem withBorder isBold>{translations?.TI2020_ContentTranslations_Header_Type}</TableRawItem>
                    </TableRaw>
                    {data.map(({ externalProjectId, projectDbType }) => {
                        return (
                            <TableRaw key={externalProjectId}>
                                <TableRawItem isCheckbox>
                                    <CheckBox
                                        disabled={data.length === 1}
                                        checked={checkedItems?.includes(externalProjectId)}
                                        onChange={(checked) => handleCheck(checked, externalProjectId)}
                                    />
                                </TableRawItem>
                                <TableRawItem>{externalProjectId}</TableRawItem>
                                <TableRawItem withBorder>{projectDbType}</TableRawItem>
                            </TableRaw>
                        );
                    })}
                </ScrollPanel>
            </TableContainer>
        );
    }
);
